import React, { forwardRef } from 'react';

import CloseIcon from '@static/images/icons/close.svg';
import { PrivacyProps } from './PrivacyProps';

import * as styles from './Privacy.module.scss';

export const Privacy = forwardRef<HTMLDivElement, PrivacyProps>(
	({ handleClosePopup }, ref) => {
		return (
			<div className={styles.privacyPopup}>
				<div className={styles.popupInner} ref={ref}>
					<button className={styles.popupCloseBtn} onClick={handleClosePopup}>
						<img alt="Schließen Symbol" src={CloseIcon} />
					</button>
					<div className={styles.popupContent}>
						<p className={styles.popupContentTitle}>
							Cookie-Richtlinie für EMBIQ Sp. z o.o.
						</p>

						<div className={styles.popupContentSection}>
							<p className={styles.popupContentSectionTitle}>
								Was sind Cookies
							</p>
							<p>
								Wie üblich bei fast allen professionellen Websites verwendet
								auch diese Seite Cookies, die kleinen Dateien sind, die auf
								Ihren Computer heruntergeladen werden, um Ihre Erfahrung zu
								verbessern. Diese Seite beschreibt, welche Informationen
								gesammelt werden, wie wir sie verwenden und warum wir manchmal
								diese Cookies speichern müssen. Außerdem wird erklärt, wie Sie
								verhindern können, dass diese Cookies gespeichert werden.
								Beachten Sie jedoch, dass dadurch möglicherweise bestimmte
								Funktionen der Website beeinträchtigt werden. Weitere allgemeine
								Informationen zu Cookies finden Sie im Wikipedia-Artikel zu
								HTTP-Cookies...
							</p>
						</div>

						<div className={styles.popupContentSection}>
							<p className={styles.popupContentSectionTitle}>
								Wie wir Cookies verwenden
							</p>
							<p>
								Wir verwenden Cookies aus verschiedenen Gründen, die unten
								detailliert beschrieben sind. Leider gibt es in den meisten
								Fällen keine branchenüblichen Optionen zum Deaktivieren von
								Cookies, ohne die Funktionalität und Features dieser Website
								vollständig zu beeinträchtigen. Es wird empfohlen, alle Cookies
								aktiviert zu lassen, wenn Sie nicht sicher sind, ob Sie sie
								benötigen, falls sie zur Bereitstellung eines von Ihnen
								genutzten Dienstes verwendet werden. Deaktivierung von Cookies
								Sie können die Einstellung von Cookies durch Anpassung der
								Einstellungen Ihres Browsers verhindern (siehe Hilfe Ihres
								Browsers, wie dies geschieht). Beachten Sie jedoch, dass das
								Deaktivieren von Cookies die Funktionalität dieser und vieler
								anderer Websites, die Sie besuchen, beeinträchtigen wird. Das
								Deaktivieren von Cookies führt in der Regel auch zur
								Deaktivierung bestimmter Funktionen und Features dieser Website.
								Daher wird empfohlen, Cookies nicht zu deaktivieren.
							</p>
						</div>

						<div className={styles.popupContentSection}>
							<p className={styles.popupContentSectionTitle}>
								Die von uns gesetzten Cookies
							</p>
							<p>
								Diese Website bietet E-Commerce- oder Zahlungsfunktionalitäten
								und einige Cookies sind unerlässlich, damit Ihre Bestellung
								zwischen den Seiten gespeichert bleibt, damit wir sie
								ordnungsgemäß verarbeiten können. Gelegentlich bieten wir
								Benutzerumfragen und Fragebögen an, um Ihnen interessante
								Einblicke, hilfreiche Tools oder ein besseres Verständnis
								unserer Benutzerbasis zu bieten. Diese Umfragen können Cookies
								verwenden, um sich daran zu erinnern, wer bereits an einer
								Umfrage teilgenommen hat oder um Ihnen nach dem Seitenwechsel
								genaue Ergebnisse bereitzustellen. Wenn Sie Daten über ein
								Formular wie solche auf Kontaktseiten oder Kommentarformularen
								senden, können Cookies gesetzt werden, um Ihre Benutzerdetails
								für zukünftige Korrespondenz zu speichern. Um Ihnen ein
								großartiges Erlebnis auf dieser Website zu bieten, bieten wir
								die Möglichkeit, Ihre Präferenzen dafür festzulegen, wie diese
								Website läuft, wenn Sie sie nutzen. Um sich an Ihre Präferenzen
								zu erinnern, müssen wir Cookies setzen, damit diese
								Informationen bei jeder Interaktion mit einer Seite abgerufen
								werden können, die von Ihren Präferenzen beeinflusst wird.
							</p>
						</div>

						<div className={styles.popupContentSection}>
							<p className={styles.popupContentSectionTitle}>
								Cookies von Drittanbietern
							</p>
							<p>
								In einigen speziellen Fällen verwenden wir auch Cookies von
								vertrauenswürdigen Drittanbietern. Im folgenden Abschnitt werden
								die Drittanbieter-Cookies erläutert, auf die Sie möglicherweise
								über diese Website stoßen. Diese Website verwendet Google
								Analytics, einen der verbreitetsten und vertrauenswürdigsten
								Analysedienste im Web, um zu verstehen, wie Sie die Website
								nutzen, und um zu erfahren, wie wir Ihr Nutzungserlebnis
								verbessern können. Diese Cookies können Dinge wie die
								Verweildauer auf der Website und die Seiten, die Sie besuchen,
								verfolgen, damit wir weiterhin ansprechende Inhalte produzieren
								können. Weitere Informationen zu Google Analytics-Cookies finden
								Sie auf der offiziellen Google Analytics-Seite.
								Drittanbieter-Analysen werden verwendet, um die Nutzung dieser
								Website zu verfolgen und zu messen, damit wir weiterhin
								ansprechende Inhalte produzieren können. Diese Cookies können
								Dinge wie die Verweildauer auf der Website oder die von Ihnen
								besuchten Seiten verfolgen, was uns hilft zu verstehen, wie wir
								die Website für Sie verbessern können. Gelegentlich testen wir
								neue Funktionen und führen subtile Änderungen an der Art und
								Weise durch, wie die Website bereitgestellt wird. Wenn wir noch
								neue Funktionen testen, können diese Cookies verwendet werden,
								um sicherzustellen, dass Sie eine konsistente Erfahrung auf der
								Website erhalten, während wir gleichzeitig verstehen, welche
								Optimierungen unsere Benutzer am meisten schätzen. Da wir
								Produkte verkaufen, ist es für uns wichtig, Statistiken darüber
								zu verstehen, wie viele der Besucher unserer Website tatsächlich
								einen Kauf tätigen, und daher handelt es sich bei diesen Daten
								um die Art von Daten, die diese Cookies verfolgen werden. Dies
								ist wichtig für Sie, da es bedeutet, dass wir genaue
								Geschäftsprognosen treffen können, die es uns ermöglichen,
								unsere Werbung und Produktkosten zu überwachen, um den
								bestmöglichen Preis zu gewährleisten. In einigen Fällen können
								wir Ihnen benutzerdefinierte Inhalte basierend auf Informationen
								bereitstellen, die Sie uns entweder direkt oder indirekt über
								eine Verknüpfung eines Social-Media-Kontos mitteilen. Diese
								Arten von Cookies ermöglichen es uns einfach, Ihnen Inhalte
								bereitzustellen, von denen wir glauben, dass sie für Sie von
								Interesse sein könnten. Wir verwenden auch
								Social-Media-Schaltflächen und/oder -Plugins auf dieser Website,
								die es Ihnen ermöglichen, auf verschiedene Weise mit Ihrem
								sozialen Netzwerk zu interagieren. Damit diese funktionieren,
								setzen die folgenden Social-Media-Sites, einschließlich;
								Facebook, Twitter, Instagram, LinkedIn, Cookies über unsere
								Website, die möglicherweise verwendet werden, um Ihr Profil auf
								ihrer Website zu verbessern oder um zu den Daten beizutragen,
								die sie für verschiedene in ihren jeweiligen
								Datenschutzrichtlinien erläuterte Zwecke halten.
							</p>
						</div>

						<div className={styles.popupContentSection}>
							<p className={styles.popupContentSectionTitle}>
								Weitere Informationen
							</p>
							<p>
								Hoffentlich hat das die Dinge für Sie klargestellt und wie
								bereits erwähnt, wenn es etwas gibt, bei dem Sie sich nicht
								sicher sind, ob Sie es benötigen oder nicht, ist es in der Regel
								sicherer, Cookies aktiviert zu lassen, falls diese mit einer der
								Funktionen interagieren, die Sie auf unserer Website verwenden.
								Wenn Sie jedoch immer noch nach weiteren Informationen suchen,
								können Sie uns über eine unserer bevorzugten Kontaktmethoden
								kontaktieren.
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
);

